<template>
  <div>
    <div style="margin-bottom: 10px" class="df both-side">
      <a-space>
        <a-date-picker v-model:value="requestPayload.localDate" @change="handleSelectLocalDate" />

        <a-range-picker v-model:value="selectRangeDay" @change="handleSelectRangeDay" />

        <a-select v-model:value="requestPayload.questionType" style="width: 100px" placeholder="问题类型" allowClear
          @change="handleSearch" :options="props.type === 'oqc' ? oqcProblemOption : processProblemOption
          ">
        </a-select>

        <a-cascader v-model:value="modelSpecifications" style="width: 190px" placeholder="设备类型" allowClear
          @change="handleSelectModelSpecifications" :options="modelSpecificationsOption">
        </a-cascader>

        <a-select v-model:value="requestPayload.status" style="width: 100px" placeholder="送检状态" allowClear
          @change="handleSearch">
          <a-select-option value="未检">未检</a-select-option>
          <a-select-option value="合格">合格</a-select-option>
          <a-select-option value="不合格">不合格</a-select-option>
        </a-select>

        <a-input-number v-model:value="requestPayload.inspectionFrequency" placeholder="送检次数" @change="handleSearch"
          allowClear />

        <a-input v-model:value="requestPayload.search" placeholder="搜索" @change="handleSearch" allowClear>
        </a-input>
      </a-space>
    </div>

    <div class="df both-side" style="margin-top: 20px">
      <div>
        <a-table :columns="pqcSetting.columns" :data-source="tableData" :pagination="false" :rowClassName="(record, index) => (index % 1 === 0 ? 'table-striped' : null)
          " rowKey="id" bordered style="width: calc(100vw - 540px)" :scroll="{
          x: 'width: calc(100vw - 540px)',
          y: 'calc(100vh - 320px)',
        }">
          <template #status="{ record }">
            <a-tag :color="setColor(record.status)">{{ record.status }}</a-tag>
          </template>
          <template #questionType1="{ record }">
            <div v-if="record.questionType1">
              <div v-for="(item, index) in record.questionType1" :key="index">
                {{ item }}
              </div>
            </div>
          </template>
          <template #reason1="{ record }">
            <div v-if="record.reason1">
              <div v-for="(item, index) in record.reason1" :key="index">
                {{ item }}
              </div>
            </div>
          </template>
          <template #reason2="{ record }">
            <div v-if="record.reason2">
              <div v-for="(item, index) in record.reason2" :key="index">
                {{ item }}
              </div>
            </div>
          </template>
          <template #solution1="{ record }">
            <div v-if="record.solution1">
              <div v-for="(item, index) in record.solution1" :key="index">
                {{ item }}
              </div>
            </div>
          </template>
          <template #solution2="{ record }">
            <div v-if="record.solution2">
              <div v-for="(item, index) in record.solution2" :key="index">
                {{ item }}
              </div>
            </div>
          </template>
          <template #question1="{ record }">
            <div v-for="(img, index) in record.issuesImg1" :key="index">
              <a-image :width="50" :src="img" />
            </div>
            <div v-for="(video, index) in record.issuesVideo1" :key="index">
              <video :src="video" controls width="120" :key="video"></video>
            </div>
            <div v-for="(item, index) in record.issuesDesc1" :key="index">
              {{ item }}
            </div>
          </template>
          <template #question2="{ record }">
            <div v-for="(img, index) in record.issuesImg2" :key="index">
              <a-image :width="50" :src="img" />
            </div>
            <div v-for="(video, index) in record.issuesVideo2" :key="index">
              <video :src="video" controls width="120" :key="video"></video>
            </div>
            <div v-for="(item, index) in record.issuesDesc2" :key="index">
              {{ item }}
            </div>
          </template>
          <template #questionType2="{ record }">
            <div v-if="record.questionType2">
              <div v-for="(item, index) in record.questionType2" :key="index">
                {{ item }}
              </div>
            </div>
          </template>

          <template #sourceProcess="{ record }">
            {{ getProcessName(record.sourceProcess) }}
          </template>

          <template #notes="{ record }">
            <div v-if="record.notes">
              <template v-for="(item, index) in JSON.parse(record.notes)" :key="index">
                <a-image v-for="img in JSON.parse(item.picture)" :key="img" :width="50" :src="img" />

                <video v-for="video in JSON.parse(item.video)" :src="video" controls width="120" :key="video"></video>

                <div>
                  {{ item.desc }}
                </div>
              </template>
            </div>
          </template>

          <template #closedLoopStatus="{ record }">
            <closed-loop-status :closedLoopStatus="record.closedLoopStatus"></closed-loop-status>
          </template>

          <template #action="{ record }">
            <a-space>
              <a-button v-if="pqcSetting.PFOAuthority" @click="handleEdit(record)" size="small">编辑</a-button>
              <!-- <a-button
            @click="handleDeleteCommon(record)"
            type="danger"
            size="small"
            >删除</a-button
          > -->

              <!-- <a-popconfirm v-if="checkWarehouse(props.type, record.status, record.isToFQC)" title="确认入库到成品？"
                ok-text="是" cancel-text="否" @confirm="handleInsertWarehouse(record)">
                <a-button size="small" type="primary"> 入库 </a-button>
              </a-popconfirm> -->
            </a-space>
          </template>
        </a-table>

        <div class="df" style="justify-content: flex-end; width: 100%" v-if="props.type === 'fqc'">
          <a-pagination v-model:current="requestPayload.pageNum" v-model:pageSize="requestPayload.lineNum"
            :total="requestPayload.total" :show-total="(total) => `共 ${total} 条`" size="small" @change="getData"
            style="margin-top: 10px" />
        </div>
      </div>

      <pass-rate-table-vue  :passRateData="passRateData"
        :title="pqcSetting.type"></pass-rate-table-vue>
    </div>

    <pqc-form ref="pqcformRef" :type="props.type" :ROSAuthority="pqcSetting.ROSAuthority" @updateTable="handleSearch"
      @handleInsertWarehouse="handleInsertWarehouse"></pqc-form>
  </div>
</template>

<script>
import { defineComponent, inject, reactive, ref, watch } from "vue";
import {
  deletePQC,
  getPQCList,
  getPQCQualifiedSituation,
  getOQCQualifiedSituation,
} from "@/request/view/dailyQualityInspection";
import {
  PQCToFQC,
  getFQCQualifiedSituation,
  getFQCList,
  getOQCList,
} from "@/request/view/warehouse";
import { debounce, timeStampToTime, Toast } from "@/utils";
import { modelSpecificationsOption } from "@/views/productDaily/serve/option";
import { getPassRateTableData } from "@/views/productDaily/components/quality/serve/passRate";
import { getProcessName } from "@/views/productDaily/serve/option";
import { processProblemOption } from "@/views/productDaily/components/quality/PQC/view/serve/option";
import { oqcProblemOption } from "@/views/productDaily/warehouse/option";
import passRateTableVue from "@/views/productDaily/components/quality/PassRate/passRateTable.vue";
import pqcForm from "@/views/productDaily/components/quality/PQC/view/components/form.vue";
import { checkWarehouse } from "@/views/productDaily/components/quality/PQC/view/serve/condition";
import { showModal } from "@/views/repairprogress/serve/modal";

export default defineComponent({
  props: {
    type: String,
  },
  components: {
    passRateTableVue,
    pqcForm,
  },
  setup(props, context) {
    // 设置
    const pqcSetting = inject("pqcSetting", {
      produceOrTpc: null,
      columns: [],
      name: null,
      type: null,
      PFOAuthority: false,
      ROSAuthority: false,
    });

    const modelSpecifications = ref([]);

    const setColor = (status) => {
      let color = "";
      switch (status) {
        case "未检":
          color = "orange";
          break;
        case "不合格":
          color = "#f50";
          break;
        case "合格":
          color = "#87d068";
          break;
        default:
          break;
      }
      return color;
    };

    const pqcformRef = ref();

    /**
     * 请求参数
     */
    const requestPayload = reactive({
      status: null,
      startDate: null,
      endDate: null,
      inspectionFrequency: null,
      localDate: timeStampToTime("", "upload"),
      modelSpecifications: null,
      produceOrTpc: pqcSetting.produceOrTpc,
      questionType: null,
      search: null,
      sourceProcess: null,
      type: props.type,
      pageNum: 1,
      lineNum: 10,
      total: 0,
    });

    const selectRangeDay = ref([]);

    const tableData = reactive([]);

    const handleUpdateProject = (record) => {
      console.log(record, "+++++++++++++++");
    };

    const handleProjectDetails = (record) => {
      console.log(record);
    };

    const passRateData = reactive([]);

    // PQC合格率汇总
    const getPassRateData = () => {
      let reqFn = getPQCQualifiedSituation;

      if (props.type === 'oqc' || props.type === 'fqc') {
        reqFn =
        props.type === "oqc"
          ? getOQCQualifiedSituation
          : getFQCQualifiedSituation;
      }
        
      reqFn({
        type: requestPayload.type,
        localDate: requestPayload.localDate,
        endDate: requestPayload.endDate,
        startDate: requestPayload.startDate,
        produceOrTpc: requestPayload.produceOrTpc,
      })
        .then((res) => {
          passRateData.length = 0;
          if (
            res.code === 200 &&
            res.message === "成功" &&
            res.data &&
            Object.keys(res.data).length > 0
          ) {
            let data = res.data[pqcSetting.type];

            if (props.type === 'fqc' || props.type === 'oqc') {
              data = res.data;
            }

            const rateData = getPassRateTableData(data);
            passRateData.push(...rateData);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    // 设置渲染数据
    const setmediaInfo = (list) => {
      console.log(list, "table data");
      if (!list) return;
      list.forEach((item) => {
        if (
          item.inspectionIssues &&
          item.inspectionIssues.indexOf("[") !== -1
        ) {
          const list = JSON.parse(item.inspectionIssues);
          if (typeof list === "object")
            list.forEach((issues, index) => {
              item[`issuesDesc${index + 1}`] = [];
              item[`issuesImg${index + 1}`] = [];
              item[`issuesVideo${index + 1}`] = [];
              item[`questionType${index + 1}`] = [];
              issues.list.forEach((media) => {
                item[`issuesImg${index + 1}`].push(
                  ...JSON.parse(media.picture)
                );
                item[`issuesVideo${index + 1}`].push(
                  ...JSON.parse(media.video)
                );
                item[`questionType${index + 1}`].push(media.type);
                item[`issuesDesc${index + 1}`].push(media.desc);
                item[`reason${index + 1}`] = media.reason;
                item[`solution${index + 1}`] = media.solution;
              });
              item[`inspectionPersonnel${index + 1}`] =
                issues.inspectionPersonnel;
              item[`qualityPersonnel${index + 1}`] =
                issues.qualityPersonnel;
            });
        }
      });
    };

    const getRequestByType = () => {
      let requestFn;
      const params = {};
      params.status = requestPayload.status;
      params.startDate = requestPayload.startDate;
      params.endDate = requestPayload.endDate;
      params.inspectionFrequency = requestPayload.inspectionFrequency;
      params.localDate = requestPayload.localDate;
      params.modelSpecifications = requestPayload.modelSpecifications;
      params.produceOrTpc = requestPayload.produceOrTpc;
      params.questionType = requestPayload.questionType;
      params.search = requestPayload.search;
      params.sourceProcess = requestPayload.sourceProcess;
      switch (props.type) {
        case "fqc":
          requestFn = getFQCList;
          params.pageNum = requestPayload.pageNum;
          params.lineNum = requestPayload.lineNum;
          break;
        case "oqc":
          requestFn = getOQCList;
          params.localDate = null;
          break;
        default:
          requestFn = getPQCList;
          params.type = requestPayload.type;
          break;
      }

      return {
        requestFn,
        params,
      };
    };

    // 获取PQC数据
    const getPQCData = () => {
      const { requestFn, params } = getRequestByType();
      requestFn(params)
        .then((res) => {
          tableData.length = 0;
          if (res.code === 200 && res.message === "成功" && res.data) {
            try {
              if (props.type !== "fqc" && props.type !== 'oqc') {
                Object.keys(res.data).forEach((key) => {
                  setmediaInfo(res.data[key]);
                  tableData.push(...res.data[key]);
                });
              } else if (props.type === "fqc") {
                setmediaInfo(res.data.records);
                tableData.push(...res.data.records);
              } else if (props.type === "oqc") {
                setmediaInfo(res.data);
                tableData.push(...res.data);
              }
              if (res.data.total) {
                requestPayload.total = res.data.total;
              }
            } catch (error) {
              console.log(error, "捕获到的错误是什么");
            }
          }
        })
        .catch((err) => { });
    };

    // 添加到成品入库
    const handleInsertWarehouse = (record) => {
      PQCToFQC({ pqcId: record.id }).then((res) => {
        const type = res.code === 200 ? "success" : "warning";
        Toast(type, res.message, 3);
        getPQCData();
      });
    };

    // 获取PQC 和 合格率数据
    const getData = () => {
      getPQCData();
      getPassRateData();
    };

    // 搜索数据
    const handleSearch = debounce(() => {
      requestPayload.pageNum = 1;
      getData();
    }, 100);

    // 选择时间段
    const handleSelectRangeDay = (value, dateString) => {
      const [startDate, endDate] = dateString;
      requestPayload.startDate = null;
      requestPayload.endDate = null;
      if (startDate && endDate) {
        requestPayload.startDate = startDate;
        requestPayload.endDate = endDate;
      }
      requestPayload.localDate = null;
      handleSearch();
    };

    const handleSelectModelSpecifications = (e) => {
      const [machine, type] = e;
      requestPayload.modelSpecifications = type;
      handleSearch();
    };

    const handleSelectLocalDate = (e, stringTime) => {
      requestPayload.localDate = stringTime;
      requestPayload.startDate = null;
      requestPayload.endDate = null;
      handleSearch();
    };

    // 编辑数据
    const handleEdit = (data) => {
      if (props.type === "fqc" && !data.batchNumber)
        return Toast("warning", "请在仓库成品模块中完善信息", 3);
      pqcformRef.value.openModal(data);
    };

    // 删除数据
    const handleDeleteCommon = (record) => {
      showModal({
        title: "确认删除？",
        toastText: "",
        success: () => {
          deletePQC(record.id).then((res) => {
            getData();
          });
        },
        cancel: () => {
          // Toast("info", "取消删除", 3);
        },
      });
    };

    watch(
      () => pqcSetting.type,
      (val) => {
        if (props.type === pqcSetting.type) {
          getData();
        }
      },
      {
        deep: true,
        immediate: true,
      }
    );

    return {
      props,
      getData,
      tableData,
      pqcformRef,
      pqcSetting,
      passRateData,
      requestPayload,
      selectRangeDay,
      modelSpecifications,
      processProblemOption,
      oqcProblemOption,
      modelSpecificationsOption,
      checkWarehouse,
      handleSelectModelSpecifications,
      getProcessName,
      setColor,
      handleDeleteCommon,
      handleEdit,
      handleSearch,
      handleInsertWarehouse,
      handleSelectLocalDate,
      handleSelectRangeDay,
      handleProjectDetails,
      handleUpdateProject,
    };
  },
});
</script>

<style lang="less" scoped></style>
